import { api } from '@/api'
import { useMutation } from '@tanstack/react-query'

export const useCheckout = () => {
  return useMutation({
    mutationFn: async ({ amount }: { amount: number }) => {
      const res = await api.post<{ url: string }>('/payments/checkout', {
        amount,
      })
      return res.data
    },
  })
}
